import React from 'react'
import PropTypes from 'prop-types'

import {
  newPassJade,
  newPrintedJade,
  newFailOrange,
  newInvestigationBlue,
  newMinorIssueBlue,
  newDesktopOrange,
  newSneakerBlue,
  newPrintBlue,
  newPrintOrange
} from 'images'
import Card from './Card'

const AuthCentreNotice = ({ version }) => {
  const versionList = {
    'passed-auth': {
      icon: newPassJade,
      titleColour: 'jade',
      title: 'Passed Authentication',
      subTitle: 'Put on ready for delivery label rack'
    },
    'label-printed': {
      icon: newPrintedJade,
      titleColour: 'jade',
      title: 'Label Printed',
      subTitle: 'Place delivery Label inside the sneaker’s Box'
    },
    'failed-auth': {
      icon: newFailOrange,
      titleColour: 'orange',
      title: 'Failed Authentication',
      subTitle: 'Put on ready for delivery label rack'
    },
    'requires-investigation': {
      icon: newInvestigationBlue,
      titleColour: 'blue',
      title: 'Requires Investigation',
      subTitle: 'Put on requires QA Rack'
    },
    'requires-invoice': {
      icon: newPrintOrange,
      titleColour: 'orange',
      title: 'Requires Invoice',
      subTitle: 'Please attach the printed invoice'
    },
    'requires-investigation-labelling': {
      icon: newInvestigationBlue,
      titleColour: 'blue',
      title: 'Investigation Required',
      subTitle: "Put on your station's requires QA Shelf"
    },
    'minor-issue': {
      icon: newMinorIssueBlue,
      titleColour: 'blue',
      title: 'Minor fix required',
      subTitle: "Put on your station's minor issue shelf"
    },
    'screen-size': {
      icon: newDesktopOrange,
      titleColour: 'orange',
      title: 'View on an authentication station'
    },
    'requires-auth': {
      icon: newSneakerBlue,
      titleColour: 'blue',
      title: 'Requires Authentication',
      subTitle: 'Put on ready for authentication rack'
    },
    'return-passed-auth': {
      icon: newPassJade,
      titleColour: 'jade',
      title: 'Passed Authentication',
      subTitle: 'Attach barcode sticker and place in the returns rack'
    },
    'return-failed-auth': {
      icon: newFailOrange,
      titleColour: 'orange',
      title: 'Failed Authentication',
      subTitle: 'Attach barcode sticker and place in the returns rack'
    },
    'return-to-buyer': {
      icon: newPrintBlue,
      titleColour: 'blue',
      title: 'Return to buyer',
      subTitle: 'Put on ready for delivery label rack'
    },
    'return-to-seller': {
      icon: newPrintBlue,
      titleColour: 'blue',
      title: 'Return to seller',
      subTitle: 'Put on ready for delivery label rack'
    },
    'cancellation-passed-auth': {
      icon: newPassJade,
      titleColour: 'jade',
      title: 'Passed Authentication',
      subTitle: 'Attach barcode sticker and place in the returns rack'
    }
  }

  return (
    <Card>
      <div
        style={{
          margin: '6.25rem auto',
          maxWidth: '37.5rem',
          overflowWrap: 'break-word'
        }}
      >
        <img
          alt="icon"
          style={{ margin: 'auto' }}
          src={versionList[version].icon}
        />
        <h3
          style={{
            textAlign: 'center'
          }}
        >
          <div
            className={`${versionList[version].titleColour}`}
            style={{
              marginTop: '2.5rem',
              marginBottom: versionList[version].subTitle ? '2.5rem' : '0'
            }}
          >
            {versionList[version].title}
          </div>
          {versionList[version].subTitle && (
            <div>{versionList[version].subTitle}</div>
          )}
        </h3>
      </div>
    </Card>
  )
}

AuthCentreNotice.propTypes = {
  version: PropTypes.oneOf([
    'passed-auth',
    'failed-auth',
    'requires-investigation',
    'screen-size',
    'requires-auth',
    'minor-issue',
    'requires-investigation-labelling',
    'label-printed',
    'return-passed-auth',
    'return-failed-auth',
    'return-to-buyer',
    'return-to-seller',
    'cancellation-passed-auth'
  ]).isRequired
}

export default AuthCentreNotice
